import { Controller } from 'stimulus'

export default class extends Controller {

  connect() {
    window.feather.replace()
    window.tippy('[data-tippy-content]')
  }
}
